import { createFileRoute } from "@tanstack/react-router";
import { requireAdmin } from "../lib/auth-guards";
import { AdminPage } from "@charphq/ui/components/admin/admin-page";

export const Route = createFileRoute("/admin")({
  beforeLoad: async () => {
    await requireAdmin();
  },
  component: AdminPageComponent,
});

function AdminPageComponent() {
  return <AdminPage />;
}
